/**
 * Crafted home/collection reviews carousel.
 * Mobile: native horizontal swipe + scroll-snap.
 * Desktop: prev/next arrows cycle one card at a time.
 */
(function () {
  'use strict';

  function initHomeReviews(scope) {
    var roots = (scope || document).querySelectorAll('[data-dg-hr]');
    roots.forEach(function (root) {
      if (root.dataset.dgHrReady === 'true') return;
      var viewport = root.querySelector('[data-dg-hr-viewport]');
      var track = root.querySelector('[data-dg-hr-track]');
      var prev = root.querySelector('[data-dg-hr-prev]');
      var next = root.querySelector('[data-dg-hr-next]');
      var dotsWrap = root.querySelector('[data-dg-hr-dots]');
      if (!viewport || !track) return;

      var cards = Array.prototype.slice.call(track.querySelectorAll('[data-dg-hr-card]'));
      if (!cards.length) {
        root.hidden = true;
        return;
      }

      root.dataset.dgHrReady = 'true';
      root.hidden = false;

      var index = 0;
      var dots = [];

      function cardStep() {
        if (cards.length < 2) return cards[0].offsetWidth;
        return cards[1].offsetLeft - cards[0].offsetLeft;
      }

      function maxIndex() {
        var step = cardStep();
        if (!step) return 0;
        var maxScroll = Math.max(0, track.scrollWidth - viewport.clientWidth);
        return Math.max(0, Math.round(maxScroll / step));
      }

      function clampIndex(value) {
        return Math.max(0, Math.min(value, maxIndex()));
      }

      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        dots = [];
        var total = maxIndex() + 1;
        if (total <= 1) {
          dotsWrap.hidden = true;
          return;
        }
        dotsWrap.hidden = false;
        for (var i = 0; i < total; i += 1) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'dg-hr__dot';
          dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
          dot.addEventListener('click', function (event) {
            var btn = event.currentTarget;
            var idx = dots.indexOf(btn);
            if (idx >= 0) goTo(idx, true);
          });
          dotsWrap.appendChild(dot);
          dots.push(dot);
        }
      }

      function updateChrome() {
        var max = maxIndex();
        index = clampIndex(index);
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= max;
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      function goTo(nextIndex, smooth) {
        index = clampIndex(nextIndex);
        var step = cardStep();
        viewport.scrollTo({
          left: index * step,
          behavior: smooth === false ? 'auto' : 'smooth'
        });
        updateChrome();
      }

      function syncFromScroll() {
        var step = cardStep();
        if (!step) return;
        index = clampIndex(Math.round(viewport.scrollLeft / step));
        updateChrome();
      }

      var scrollTimer = null;
      viewport.addEventListener(
        'scroll',
        function () {
          if (scrollTimer) window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(syncFromScroll, 60);
        },
        { passive: true }
      );

      if (prev) {
        prev.addEventListener('click', function () {
          goTo(index - 1, true);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          goTo(index + 1, true);
        });
      }

      viewport.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(index - 1, true);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(index + 1, true);
        }
      });

      buildDots();
      goTo(0, false);

      window.addEventListener(
        'resize',
        function () {
          buildDots();
          goTo(index, false);
        },
        { passive: true }
      );
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(function () {
    initHomeReviews(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-dg-hr]');
    if (root) root.dataset.dgHrReady = '';
    initHomeReviews(event.target);
  });
})();
